module.exports = __webpack_public_path__ + "img/lp-time.85006295.svg";